import * as signalR from '@microsoft/signalr';

const hubUrl  = 'https://api-provider.gethexperu.com/notificationHub';

const connection = new signalR.HubConnectionBuilder()
  .withUrl(hubUrl)
  .configureLogging(signalR.LogLevel.Information)
  .build();

export const startConnection = async () => {
  try {
    await connection.start();
    console.log('Conexión establecida con el servidor SignalR.');
  } catch (err) {
    connection.onclose((error) => {
      console.error('Conexión cerrada con error:', error);
    });
    connection.on("error", (error) => {
      console.error('Error en la conexión SignalR:', error);
    });
  }
};

export default connection;